import React from 'react';

import { Stack } from '@gogame/components';

import {
  SelectMetrics,
  SelectBreakdownCount,
  SelectBreakdownMetric,
} from '../Metrics';

const ChartAffix = ({ isChartBreakdownMode, metrics, isMetricsLoading }) => {
  return isChartBreakdownMode ? (
    <Stack direction={'row'} spacing={2}>
      <SelectBreakdownMetric metrics={metrics} loading={isMetricsLoading} />
      <SelectBreakdownCount />
    </Stack>
  ) : (
    <SelectMetrics metrics={metrics} loading={isMetricsLoading} />
  );
};

export default ChartAffix;
